import { Color, Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import AttributeItem from 'dashboard/components/AttributeItem';
import { UppercaseLabel } from 'dashboard/components/Typography';
import { HydratedTransactions, TransactionAccountInfo } from 'dashboard/models/graph-hydration';
import Table, {
  TableBody,
  TableCell,
  TableHead,
  TableHeaderCell,
  TableRow,
} from 'design-system/components/Table';
import { BASE } from 'design-system/variables/spacing';
import { DATUM_TYPE_DISPLAY_NAMES, TRANSACTIONS_DATUM_TYPE } from 'lib/constants/graph';

const SectionTitle = styled(UppercaseLabel)`
  color: ${Color.CoreSlate900};
`;

const AttributesColumn = styled('div')`
  display: grid;
  grid-row-gap: ${Spacing[4]};
`;

const formatRoutingAndAccountNumbers = (accountInfo: TransactionAccountInfo): string => {
  return `${accountInfo['routing-number']} ${accountInfo['account-number']}`;
};

interface GraphHoverCardTransactionsProps {
  hydratedTransactions: HydratedTransactions;
  cardMenu?: boolean;
}

const GraphHoverCardTransactions = ({
  hydratedTransactions,
  cardMenu = false,
}: GraphHoverCardTransactionsProps) => {
  const titleSpacing = cardMenu ? 0 : BASE;

  const transactionsTable = (
    <Table>
      <TableHead>
        <TableRow>
          <TableHeaderCell>Transaction ID</TableHeaderCell>
          <TableHeaderCell>Amount</TableHeaderCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {hydratedTransactions.hydrationData.transactions.map((transactionsData) => (
          // TODO(kerry): We should revisit the key here, because the customer could mess up and pick non-unique values.
          <TableRow key={transactionsData.id}>
            <TableCell>{transactionsData.id}</TableCell>
            <TableCell>
              {Number(transactionsData.amount).toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
                maximumFractionDigits: 2,
              })}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );

  return (
    <>
      <SectionTitle>{DATUM_TYPE_DISPLAY_NAMES[TRANSACTIONS_DATUM_TYPE.token]}</SectionTitle>
      <AttributesColumn>
        <AttributeItem
          title='From'
          value={formatRoutingAndAccountNumbers(hydratedTransactions.hydrationData.account1)}
          isRedacted={false}
          wordBreak='break-all'
          placeholder='-'
          dataTest='graph-transactions-hover-card__from'
          titleSpacing={titleSpacing}
        />
        <AttributeItem
          title='To'
          value={formatRoutingAndAccountNumbers(hydratedTransactions.hydrationData.account2)}
          isRedacted={false}
          wordBreak='break-all'
          placeholder='-'
          dataTest='graph-transactions-hover-card__from'
          titleSpacing={titleSpacing}
        />
        <AttributeItem
          title='Total Amount'
          value={hydratedTransactions.hydrationData.netVolume.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
            maximumFractionDigits: 2,
          })}
          isRedacted={false}
          wordBreak='break-all'
          placeholder='-'
          dataTest='graph-transactions-hover-card__amount'
          titleSpacing={titleSpacing}
        />
        <AttributeItem
          title='Transactions'
          value={transactionsTable}
          isRedacted={false}
          wordBreak='break-all'
          placeholder='-'
          dataTest='graph-transactions-hover-card__transactions-table'
          titleSpacing={titleSpacing}
        />
      </AttributesColumn>
    </>
  );
};

export default GraphHoverCardTransactions;
